import { gql } from "@apollo/client";

export const TERMS_CONDITIONS = gql`
    query BookingTermsConditions($code: String!, $culture: String!, $status: Status!) {
        termsConditions(
            where: {code: {code: $code}, localization: {culture: $culture}}
            status: $status
        ) {
            displayText
            code {
                code
            }
            htmlBody {
                html
            }
        }
    }
`;